import { isNullOrEmptyArray } from '../../../../util/arrays';

const groupBy = (data, fieldKey) => data.reduce((reduced, next) => {
  (reduced[next[fieldKey]] = reduced[next[fieldKey]] || []).push(next);
  return reduced;
}, {});

function getLabel(resultado) {
  if (resultado.alternativaPrincipal && resultado.alternativaPrincipal.enunciado) {
    return resultado.alternativaPrincipal.enunciado;
  }
  return resultado.alternativaOriginal.enunciado;
}

export function toEchartData(resultados) {
  //
  if (isNullOrEmptyArray(resultados)) return [];

  // numero de alternativas (é igual em todas as pesquisas)
  // ainda que a alternativa n existe em outra pesquisa,
  // isto eh tratado como a alternativa principal com valor 0
  const respostasSize = resultados[0].resultados.length;

  // todos os titulos da pesquisa
  const points = resultados.map((pesquisa) => pesquisa.tituloPesquisa);

  const allRespostas = resultados
    .map((pesquisa) => pesquisa.resultados)
    .reduce((reduced, next) => [...reduced, ...next]);

  /**
   * agrupando todas as respostas por ordem, o resultado disso será algo:
   * 1: [sexo,genero,Sexo]
   * 2: [religiao,Religiao,qual_sua_religiao]
   * 3: [renda,Renda,qual_sua_renda]
   */
  const respostasByOrder = groupBy(allRespostas, 'order');

  const respostasByOrderSize = Object.keys(respostasByOrder).length;
  
  const effectiveRespostasSize = Math.min(respostasSize, respostasByOrderSize);

  /**
   * criando uma array do tamanho da quant. de respostas
   * cada index+1 será usado para recuperar toda as respostas
   * iguais do mapa gerado anteriormente
   */
  const lines = [...Array(effectiveRespostasSize).keys()].map((index) => {
    const respostasSameOrder = respostasByOrder[index + 1];

    const name = getLabel(respostasSameOrder[0]);
    const results = respostasSameOrder.map((resposta) => ({
      value: resposta.resultadoPercentual,
      numeric: resposta.resultadoNumerico,
      predicted: resposta.predicted,
    }));
    /* const percentResults = respostasSameOrder.map(
      resposta => resposta.resultadoPercentual
    ); */

    return {
      name,
      results,
      // percentResults,
    };
  })
    .filter((line) => line.name !== null);

  /**
   * Gerando as legendas: que é basicamente todos os nomes
   * das alternativas principais
   */
  const legends = lines.map((line) => ({
    name: line.name,
  }));

  return {
    legends,
    points,
    lines,
  };
}
